/**
 * 用戶帳號資料信息
 */
import React from 'react';
import { useIntl, useSelector } from 'umi';
import type { UserState } from 'umi';
import { Row, Col } from 'antd';
import { isMobile } from '@/utils';
import { infoList } from './config';
import WebDataCard from '../WebDataCard';
import styles from './ApplicantInformations.less';

export interface ApplicantInformationsProps extends React.HTMLAttributes<HTMLDivElement> {}
function ApplicantInformations(props: ApplicantInformationsProps) {
  const { className = '', ...othersProps } = props;
  const mobile = isMobile();
  // 获取用户信息
  const { profile } = useSelector(({ user }: { user: UserState }) => user);

  const intl = useIntl();
  const title = intl.formatMessage({ id: '申請人資料' });

  const content = (
    <div className={styles.infoContainer}>
      {infoList.map((group, index) => (
        <Row className={styles.infoArea} key={index}>
          {group.map((item) => {
            const { key, text, render = v => v, renderKey = (v, record) => v } = item;
            //  身份證號 手機號碼不顯示
            const renderText = profile[key];
            const inputStyle = isMobile()
              ? { width: '', flex: 'auto' }
              : { width: '345px', flex: 'auto' };
            return (
              renderText && (
                <Col role="text" key={key} className={styles.listItem} span={mobile ? 24 : 12}>
                  <span className={`${styles.itemKey} ${mobile ? '' : styles.webItem}`}>
                    {intl.formatMessage({ id: renderKey(text, profile) })}
                  </span>
                  <span className={styles.itemValue} style={isMobile() ? { flex: 1 } : {}}>
                    <span style={inputStyle} className="ant-input">{render(renderText)}</span>
                  </span>
                </Col>
              )
            );
          })}
        </Row>
      ))}
    </div>
  );

  // pc端
  if (!mobile) {
    return (
      <div className={`${styles.webRoot} ${className}`} {...othersProps}>
        <WebDataCard cardTitle={title}>{content}</WebDataCard>
      </div>
    );
  }

  // 移动端
  return (
    <div className={`${styles.root} ${className}`} {...othersProps}>
      <div className={styles.titleArea}>
        <span className={styles.title}>{title}</span>
      </div>
      {content}
    </div>
  );
}

export default ApplicantInformations;
